<template lang="pug">
.v-field-range-slider.field-range-slider(:class="{'field-range-slider--disabled': field.disabled}")
	label.field-label(v-if="field.label")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	template(v-if="field.singleHandle")
		.field-range-slider__value {{localValue.max}}{{field.postfixMax}}
	template(v-else)
		.field-range-slider__values
			span.field-range-slider__value {{localValue.min}}{{field.postfixMin}}&nbsp;
			="- "
			span.field-range-slider__value {{localValue.max}}{{field.postfixMax}}
	.field-range-slider__controls
		.field-range-slider__ruler(ref="ruler")
			template(v-for="item in computedScale")
				.field-range-slider__scale-div(:style="{'left': item.percent + '%'}" :data-value="item.value")
		.field-range-slider__active(:style="{'left': position.min, 'right': position.maxReverse}")
		.field-range-slider__handle(v-if="!field.singleHandle"
				:class="{'field-range-slider__handle--z-bump': parseInt(position.min) > 98}"
				:style="{'left': position.min}"
				@mousedown.stop="mousedown('min')"
				@touchstart.stop.passive="mousedown('min')")
		.field-range-slider__handle(:style="{'left': position.max}"
				@mousedown.stop="mousedown('max')"
				@touchstart.stop.passive="mousedown('max')")
</template>

<script>
import controller from '../scripts/controller/controller';
export default {
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			rulerWidth: 0,
			drag: false
		};
	},

	computed: {
		position() {
			return {
				min: (this.localValue.min - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
				max: (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
				maxReverse: 100 - (this.localValue.max - this.field.min) / (this.field.max - this.field.min) * 100 + '%',
			};
		},

		computedScale() {
			let result = [];
			let min = this.field.min;
			let max = this.field.max;
			while (min <= max) {
				result.push({
					percent: (min / max * 100).toFixed(0),
					value: min
				});
				min += this.field.precision;
			}
			return result;
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		this.updateRulerSize();
		window.addEventListener('resize', this.updateRulerSize);
		if (controller.touch) {
			document.addEventListener('touchend', this.mouseup);
			document.addEventListener('touchmove', this.mousemove, controller.passiveEventsSupported ? {passive: true} : undefined);
		} else {
			document.addEventListener('mouseup', this.mouseup);
			document.addEventListener('mousemove', this.mousemove, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	},

	unmounted() {
		window.removeEventListener('resize', this.updateRulerSize);
		if (controller.touch) {
			document.removeEventListener('touchend', this.mouseup);
			document.removeEventListener('touchmove', this.mousemove);
		} else {
			document.removeEventListener('mouseup', this.mouseup);
			document.removeEventListener('mousemove', this.mousemove);
		}
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue || {min: this.field.min || 0, max: this.field.max || 0};
		},

		updateRulerSize() {
			this.rulerWidth = this.$refs['ruler'] && this.$refs['ruler'].offsetWidth;
		},

		mousedown(handle) {
			this.drag = handle;
		},

		mouseup() {
			if (this.drag) {
				this.$emit('update:model-value', this.localValue);
			}
			this.drag = false;
		},

		mousemove(e) {
			let pageX = e.pageX;
			if (e.changedTouches && e.changedTouches.length) {
				pageX = e.changedTouches[0].pageX;
			}
			if (this.drag && !this.field.disabled) {
				let ruler = this.$refs['ruler'];
				let rect = ruler.getBoundingClientRect();
				let diff = (pageX - rect.left) / rect.width;
				diff = Math.max(0, Math.min(1, diff));
				let val;
				let precision = this.field.precision || 1;
				let precisionString = precision.toString();
				let precisionPointIndex = precisionString.indexOf('.');

				if (this.drag === 'min') {
					val = Math.min(this.localValue.max, (this.field.max - this.field.min) * diff + this.field.min);
					val = Math.round(val / precision) * precision;
					// fix JS round bugs
					if (precisionPointIndex >= 0) {
						val = parseFloat(val.toFixed(precisionString.slice(precisionPointIndex).length));
					}
					this.localValue.min = val;
				} else if (this.drag === 'max') {
					val = Math.max(this.localValue.min, (this.field.max - this.field.min) * diff + this.field.min);
					val = Math.round(val / precision) * precision;
					// fix JS round bugs
					if (precisionPointIndex >= 0) {
						val = parseFloat(val.toFixed(precisionString.slice(precisionPointIndex).length));
					}
					this.localValue.max = val;
				}
			}
		}
	}
};
</script>
